import * as S from './PromoCodeSelector.styles'
import Coupon from './Coupon'
import promoCutLine from '../../../icons/assets/PromoCutLine.png'

interface SingleCouponSectionProps {
  headerTitle: string
  title: string
  subtitle: string
  dataTestId: string
}

// A section with a single coupon which is enabled
function SingleCouponSection({
  headerTitle,
  title,
  subtitle,
  dataTestId,
}: SingleCouponSectionProps) {
  return (
    <S.CouponContainer>
      <S.FreeTilesCouponCategoryHeader>
        <S.CouponCategoryTitle>
          <S.BoldText>{headerTitle}</S.BoldText>
        </S.CouponCategoryTitle>
      </S.FreeTilesCouponCategoryHeader>
      <S.PromoCutLine src={promoCutLine} />
      <Coupon
        title={title}
        subtitle={subtitle}
        value=""
        selectedValue=""
        isLastCoupon
        dataTestId={dataTestId}
      />
    </S.CouponContainer>
  )
}

export default SingleCouponSection
